// @flow

import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import classnames from 'classnames'
import { Trans, withI18n, i18nMark } from '@lingui/react'
import { compose, withStateHandlers } from 'recompose'

import withStyles from 'material-ui/styles/withStyles'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Drawer from 'material-ui/Drawer'
import ListItem from 'material-ui/List/ListItem'
import ListItemText from 'material-ui/List/ListItemText'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import MenuIcon from 'material-ui-icons/Menu'

const menu = {
  storitve: {
    name: i18nMark('storitve.name'),
    slug: i18nMark('storitve.slug'),
  },
  pristop: {
    name: i18nMark('pristop.name'),
    slug: i18nMark('pristop.slug'),
  },
  tehnologije: {
    name: i18nMark('tehnologije.name'),
    slug: i18nMark('tehnologije.slug'),
  },
  kontakt: {
    name: i18nMark('kontakt.name'),
    slug: i18nMark('kontakt.slug'),
  },
}

type Props = {
  classes: Object,
  i18n: Object,
  open: boolean,
  toggle: Function,
}

const Header = ({
  classes,
  i18n,
  open,
  toggle,
}: Props) => (
  <Fragment>
    <AppBar className={classes.root} position={'fixed'} color={'default'}>
      <Toolbar className={classes.toolbar}>
        <Typography
          className={classes.title}
          component={Link}
          to={'/'}
          variant={'headline'}
        >
          <Trans id='common.title' />
        </Typography>
        <IconButton
          className={classes.toggler}
          onClick={toggle}
          aria-label={i18n._('common.menu')}
        >
          <MenuIcon />
        </IconButton>
        {Object.keys(menu).map(item => (
          <Button
            key={item}
            className={classes.button}
            component={Link}
            to={`/#${i18n._(menu[item].slug)}`}
          >
            <Trans id={menu[item].name} />
          </Button>
        ))}
      </Toolbar>
    </AppBar>
    <Drawer
      open={open}
      onClose={toggle}
      PaperProps={{ className: classes.drawer }}
    >
      <Toolbar className={classes.toolbar}>
        <Typography
          className={classnames(classes.title, classes.titleBlack)}
          variant={'headline'}
          component={Link}
          to={'/'}
        >
          <Trans id='common.title' />
        </Typography>
      </Toolbar>
      {Object.keys(menu).map(item => (
        <ListItem
          key={item}
          component={Link}
          to={`/#${i18n._(menu[item].slug)}`}
          button
          onClick={toggle}
          onKeyDown={toggle}
        >
          <ListItemText
            className={classes.item}
            primary={i18n._(menu[item].name)}
            disableTypography
          />
        </ListItem>
      ))}
    </Drawer>
  </Fragment>
)

const styles = theme => ({
  root: {
    color: '#fff',
    boxShadow: 'none',
    border: 'none',
    background: 'linear-gradient(to bottom, #222936 0%,#272e3b 100%)',
    transition: 'background .3s ease-in-out',
    '@media (max-width: 960px) and (orientation: landscape)': {
      background: 'linear-gradient(to bottom, #222936 0%, #2e3540 100%)',
    },
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  title: {
    flex: '1',
    font: '0/0 a',
    color: 'transparent',
    width: '104px',
    height: '48px',
    backgroundImage: `url(${require('./images/logo-white.svg')})`,
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '104px 26px',
  },
  titleBlack: {
    backgroundImage: `url(${require('./images/logo-black.svg')})`,
  },
  toggler: {
    color: 'inherit',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  button: {
    color: 'inherit',
    textTransform: 'lowercase',
    fontWeight: '300',
    fontSize: '1.2rem',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'inline-flex',
    },
  },
  drawer: {
    width: '250px',
    '&:focus': {
      outline: 'none',
    },
    '& svg': {
      '& path': {
        fill: '#000',
      },
    },
  },
  item: {
    textTransform: 'lowercase',
    fontWeight: '300',
    fontSize: '1.2rem',
  },
})

export default compose(
  withI18n(),
  withStyles(styles),
  withStateHandlers(
    ({ initialOpen = false }) => ({
      open: initialOpen,
    }),
    {
      toggle: ({ open }) => () => ({ open: !open }),
    },
  ),
)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js